<template>
  <div class="container">
    <iframe :src="ifr" frameborder="0"></iframe>
    <ul class="aside">
      <li @click="handleItem(item)" v-for="(item,i) in aside" :key="i" class>
        <img v-if="item.name === 'bgm'" :src="`${$cdn}/assets/images/aside/${item.name}${!musicSta?'_active':''}.png`" alt />
        <img v-else-if="item.name === 'sy'" :src="`${$cdn}/assets/images/aside/${item.name}${isMain?'_active':''}.png`" alt />
        <img v-else :src="`${$cdn}/assets/images/aside/${item.name}${(activeType===item.name)&&listVisable?'_active':''}.png`" alt />
      </li>
    </ul>

    <div v-if="isMain&&!isMobile" class="itroduce">
      <img :src="`${$cdn}/assets/images/introduce.png`" alt />
      <h2>陈芳家宅</h2>
      <p>陈芳家宅位于珠海市香洲区梅溪村，建于1891至1896年，于2006年被列为全国重点文物保护单位。故居包括陈公祠一座、大屋三座、洋楼和花厅各一座。现存建筑面积2495平方米，占地面积5742平方米，是融合中西方建筑艺术风格为一体的建筑精品。</p>
    </div>

    <div class="title" v-if="!isMain&&acItem.type==='panorama'">{{title}}</div>

    <listSwiper
          v-if="listVisable"
          @close="()=>{listVisable = false}"
          @handleItem="handleClick"
          @msgsActive="handleMsgs"
          :active="activeLink"
        />
    </div>
</template>

<script>
import listSwiper from "@/components/listSwiper";
import { data } from "@/components/data";
import browser from '@/utils/browser'

const aside = [
  {
    id: "",
    name: "sy"
  },
  {
    id: "",
    name: "scene"
  },
  {
    id: "",
    name: "bgm"
  }
];
export default {
  name: "Home",
  data() {
    return {
      bgm:'',
      active: false,
      aside,
      acItem:'',
      listVisable: false,
      detailVisable: false,
      activeType: "",
      activeLink:'',
      activeDetail: "",
      musicSta: true,
      isMobile: browser.mobile,
      mus: "",
      ifr: this.$cdn + "/panorama/overview/vtour/tour.html"
    };
  },
  watch: {
    musicSta(val) {
      this.$emit('audio',val)
    },
    bgm(val){
      console.log('val',val);
      this.$emit('bgm',{
        val,
        state:this.musicSta
      })
    }
    // '$route.query.noMusic':function (val) {
    //   this.musicSta = !val
    // }
  },
  computed: {
    isMain(){
      return this.ifr.indexOf('overview')>-1
    },
    titleImg() {
      let { ifr } = this.$route.query;

      return !ifr
        ? `${this.$cdn}title/FKQAD.png`
        : ``;
    },
    title(){
      return this.acItem.text
    }
  },
  components: {
    listSwiper
  },
  methods: {
    handleMsgs(data) {
      this.detailVisable = true;
      this.activeDetail = data.item;
    },
    handleItem(item) {
      if (item.name === "sy") {
        this.activeLink = ''
        this.bgm ='19首页cp'
        this.ifr = this.$cdn + "/panorama/overview/vtour/tour.html"
        return 
      }

      if (item.name === "bgm") {
        return this.musicSta = !this.musicSta
      }

      this.listVisable = !this.listVisable;
      this.activeType = item.name;
    },
    handleClick(item){
      this.acItem = item
      this.activeLink = item.link
      this.bgm = item.audio||''
      if (item.type=='bigscene') {
        this.ifr = `https://www.4dmodel.com/SuperTwo/index.html?m=${item.link}`
      }
      else if (item.type=='4dkankan') {
        this.ifr = `https://www.4dkankan.com/showPC.html?m=${item.link}`
      }
      else{
        this.ifr = this.$cdn + `/panorama/place/vtour/tour.html?startscene=scene_${item.link}`
      }
    }
  },
  mounted() {
  setTimeout(() => {
    this.bgm ='19首页cp'
    this.musicSta = true
  });
   window.addEventListener("message", (res) => {
      if (Object.prototype.toString.call(res.data) == "[object String]") {
        let acItem = data.find((item) => item.tag === res.data) || data[0];
        if (!acItem) {
          return;
        }
        this.handleClick(acItem)
      }
    });
  }
};
</script>

<style lang="less" scoped>
.container {
  width: 100%;
  height: 100%;
  margin: 0 auto;
  position: relative;
  overflow: hidden;
  iframe {
    width: 100%;
    height: 100%;
  }

  .itroduce{
    position: fixed;
    top: 50px;
    left: 50px;
    color: #fff;
    width: 405px;
    padding: 25px;
    >img{
      position: absolute;
      top: 0;
      left: 0;
      z-index: 0;
      width: 100%;
      height: 100%;
    }
    >h2{
      z-index: 1;
      position: relative;
      border-bottom: 1px #fff solid;
      padding-bottom: 10px;
    }
    >p{
      line-height: 28px;
      z-index: 1;
      position: relative;
      padding-top: 10px;
      text-align: justify;
    }
  }

  .title{
    background: rgba(0, 0, 0, 0.2);
    border-radius: 10px;
    padding: 0 10px;
    min-width: 180px;
    position: fixed;
    top: 16px;
    left: 50%;
    z-index: 99;
    text-align: center;
    color: #fff;
    line-height: 38px;
    height: 38px;
    transform: translateX(-50%);
    cursor: pointer;
    transition: 0.3s all ease;
    &:hover{
      background: rgba(0, 0, 0, 0.5);
    }
  }
 
  .aside {
    position: fixed;
    right: 32px;
    top: 50%;
    transform: translateY(-50%);
    li {
      cursor: pointer;
      margin: 25px 0;
      img {
        width: 90px;
      }
    }
  }
  .swiper-mask {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    .btn {
      position: absolute;
      right: 10px;
      top: 10px;
      background: #fb3802;
      border-radius: 4px;
      line-height: 30px;
      height: 30px;
      color: #fff;
      display: inline-block;
      padding: 0 10px;
      width: 80px;
      text-align: center;
      z-index: 999999;
    }
  }

  .detail {
    z-index: 6666;
    background: rgba(0, 0, 0, 1);
  }

  .musicicon {
    position: fixed;
    left: 10px;
    bottom: 10px;
    img {
      width: 40px;
      height: auto;
    }
  }
}
@media screen and (max-width: 500px) {
  .container {
    max-width: 500px;
    .aside {
      right: 12px;
      top: 10px;
      transform: translateY(0%);
      li {
        margin: 15px 0;
        img {
          width: 70px;
        }
      }
    }
  }
}
</style>